import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Token is also kept in localStorage so <a>/<img> downloads can pass ?auth=
export function getToken() {
  return localStorage.getItem("vms_token") || "";
}
export function setToken(t) {
  if (t) localStorage.setItem("vms_token", t);
}
export function clearToken() {
  localStorage.removeItem("vms_token");
}

export default api;
